import type { MessageEnvelope } from "../schemas/envelope.js";
import { MessageEnvelopeSchema } from "../schemas/envelope.js";
import type { RelayControlMessage } from "../schemas/relay-control.js";
import { MESSAGE_ENVELOPE_VERSION } from "../constants/envelope.js";

// 构建经过 schema 验证的消息信封
// seq 由调用方提供；session-scoped envelope 应使用该会话单调递增的发送序号。
// sessionId 仅 session-scoped envelope 携带; 全局广播 (session_list / heartbeat / auth /
// sync_*) 传 null 或省略, 否则要求合法 ID。
export function buildMessage<T extends MessageEnvelope["type"]>(
  type: T,
  sessionId: string | null,
  seq: number,
  payload: Extract<MessageEnvelope, { type: T }>["payload"],
  source: "proxy" | "client",
): Extract<MessageEnvelope, { type: T }> {
  const envelope = {
    seq,
    ...(sessionId !== null ? { sessionId } : {}),
    type,
    payload,
    timestamp: Date.now(),
    source,
    version: MESSAGE_ENVELOPE_VERSION,
  };
  return MessageEnvelopeSchema.parse(envelope) as Extract<MessageEnvelope, { type: T }>;
}

// 序列化 relay control 消息。借助 RelayControlMessage 这个 discriminated union，
// 调用方传入 { type, ... } 时 TypeScript 会按 type 反查出该消息允许携带的字段集，
// 替代之前散落的 sendRaw(JSON.stringify({ type: "...", ... })) 模式 —— 后者在编译期
// 完全没有约束，任何字段拼写错误 / 字段漏填都到 wire 上才暴露。
//
// 这里没有再做一次 RelayControlSchema.parse(msg)：proxy 在热路径每条 envelope 都要发，
// 重复 zod 解析对吞吐有压力；编译期类型检查已经能挡住大部分错误。
// 真要做运行时校验时，调用 RelayControlSchema.parse(msg) 再 stringify 即可。
export function serializeControl(msg: RelayControlMessage): string {
  return JSON.stringify(msg);
}
